import React from 'react';
import { ILead } from 'src/interfaces/lead';
import { IStore } from 'src/interfaces/store';
import { LeadInformationCard } from './LeadInformationCard';

type AppointmentLeadInformationCardProps = {
    lead: ILead;
    store: IStore;
    canBeRejected: boolean;
    appointmentId: string;
    setOpen: (open: boolean) => void;
};

export const AppointmentLeadInformationCard = ({
    lead,
    store,
    canBeRejected,
    appointmentId,
    setOpen,
}: AppointmentLeadInformationCardProps) => {
    return (
        <LeadInformationCard
            lead={lead}
            store={store}
            canBeRejected={canBeRejected}
            taskId={appointmentId}
            setOpen={setOpen}
        />
    );
};

